import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'
import { QUERY_KEY } from './getByIdV3'

export type EngagementOrganizationResponse = {
  organization: { id: string; name: string }
}

export function useGetOrganization(id?: string, options?: { enabled: boolean }) {
  return useQuery({
    queryKey: [QUERY_KEY, id, 'organization'],
    queryFn: async () => {
      const { data } = await apiClient.get<EngagementOrganizationResponse>(
        `/int/v3/engagements/${id}/organization`
      )
      return data
    },
    enabled: Boolean(id) && options?.enabled === true,
    retry: false,
  })
}
